<div
  class="container {{ vm.editMode ? 'disabled' : '' }}"
  (dragover)="$event.preventDefault()"
  (dragenter)="vm.onMediaFilesDragEnter()"
  (dragleave)="vm.onMediaFilesDragLeave()"
  (drop)="vm.onMediaFilesDrop($event)"
>
  <div
    class="media-list"
    [style.display]="vm.mediaItemsToTranscode.length > 0 ? 'block' : 'none'"
  >
    <table>
      <thead>
        <tr>
          <th>Video Title</th>
          <th>Video ID</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let item of vm.mediaItemsToTranscode"
          [ngClass]="{
            selected: vm.editMode === false && item === vm.selectedMediaItem,
            trimmed:
              vm.editMode === false &&
              item.trimmed && item !== vm.selectedMediaItem
          }"
        >
          <td>
            <div class="truncate" title="{{item.videoTitle}}">{{ item.videoTitle }}</div>
          </td>
          <td>
            <div class="truncate" title="{{item.videoId}}">{{ item.videoId }}</div>
          </td>
          <td>
            <div class="action-buttons" *ngIf="vm.editMode === false">
              <div
                class="trim-btn"
                (click)="vm.selectItemForTrimming(item)"
              ></div>
              <remove-button
                [overrideClass]="'coral-hover-black'"
                (click)="vm.removeItem(item)"
              ></remove-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div
    class="dropbox"
    [style.display]="vm.mediaItemsToTranscode.length === 0 ? 'block' : 'none'"
  >
    <div class="drop-area">
      <span *ngIf="!vm.onMediaFilesDrag">Drag</span
      ><span *ngIf="vm.onMediaFilesDrag">Drop</span> here!
    </div>
  </div>
</div>

